<script setup>
import emitter from "@/utils/bus"; // 通信对象
import { ref } from "vue";
import { setLocalStorage, getLocalStorage, appHapticFeedback } from "@/utils/common";
import closeIcon from "@/assets/icon/close.svg";
import { useConfigStore } from "@/store/config";
import { useRouter } from "vue-router";
let router = useRouter();

const config = useConfigStore();

let nowLanguage = ref("en");
let useLanguage = ref("");
let isShow = ref(false);
let nowLa = getLocalStorage("nowLanguage") ? getLocalStorage("nowLanguage") : "en"; // 尝试获取存储的数据
nowLanguage.value = nowLa;
useLanguage.value = nowLa;
let onchenge = (res) => {
  appHapticFeedback();
  nowLanguage.value = res;
};
let save = async () => {
  appHapticFeedback();
  emitter.emit("language", nowLanguage.value);
  setLocalStorage("nowLanguage", nowLanguage.value); // 本地存储语言信息
  useLanguage.value = useLanguage.value;
  //isShow.value = false;

  window.location.reload();
};

emitter.on("showLanguage", (res) => {
  nowLa = getLocalStorage("nowLanguage") ? getLocalStorage("nowLanguage") : "en"; // 尝试获取存储的数据
  nowLanguage.value = nowLa;
  useLanguage.value = nowLa;
  isShow.value = res;
});

let language = ref([
  // {
  //   id: "zh",
  //   icon: "cn",
  //   text: "中文",
  // },
  {
    id: "en",
    icon: "um",
    text: "English",
  },
  {
    id: "fa",
    icon: "ir",
    text: "فارسی",
  },
  {
    id: "ru",
    icon: "ru",
    text: "Русский язык",
  },
  {
    id: "id",
    icon: "id",
    text: "Bahasa Indonesia",
  },
  {
    id: "ar",
    icon: "arab",
    text: " العربية",
  },
  {
    id: "tr",
    icon: "cy",
    text: " Türkçe",
  },
  {
    id: "uk",
    icon: "ua",
    text: "Українська мова",
  },
  {
    id: "fr",
    icon: "fr",
    text: "Français",
  },
  {
    id: "es",
    icon: "es",
    text: "Español",
  },
  {
    id: "pt",
    icon: "pt",
    text: "Português",
  },
  {
    id: "hi",
    icon: "in",
    text: "हिंदी",
  },
  {
    id: "ko",
    icon: "kr",
    text: "한국어",
  },
  {
    id: "ja",
    icon: "jp",
    text: "日本語",
  },
  {
    id: "ur",
    icon: "pk",
    text: "اردو",
  },
  {
    id: "uz",
    icon: "uz",
    text: "O'zbekcha",
  },
  {
    id: "vi",
    icon: "vn",
    text: "Tiếng Việt",
  },
  {
    id: "pl",
    icon: "pl",
    text: "Polski",
  },
  {
    id: "fil",
    icon: "ph",
    text: "Filipino",
  },
  {
    id: "de",
    icon: "de",
    text: "Deutsch",
  },
  {
    id: "th",
    icon: "th",
    text: "ไทย",
  },
  {
    id: "bn",
    icon: "bd",
    text: "বাংলা",
  }
]);
if (import.meta.env.DEV) {
  language.value.push({
    id: "zh",
    icon: "cn",
    text: "中文",
  });
}
</script>

<template>
  <div class="view" v-show="isShow">
    <div class="language">
      <div class="top">
        <div class="top_left">
          <div class="top_title">{{ $t("message.language") }}</div>
          <div class="top_introduced">{{ $t("message.Youcanchangethelanguagehere") }}</div>
        </div>
        <div class="close" @click="isShow = false">
          <img :src="closeIcon" alt="" />
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in language" :key="index" @click="onchenge(item.id)">
          <div :class="'img ' + `fi-${item.icon}`"></div>
          <div>{{ item.text }}</div>
          <div v-show="useLanguage == item.id && nowLanguage != useLanguage">
            {{ $t("message.current") }}
          </div>
          <div v-show="nowLanguage == item.id">✓</div>
        </div>
      </div>
      <!-- :style="{ backgroundColor: config.themes_color }" -->
      <div class="button" @click="save">{{ $t("message.save") }}</div>

    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/surfaces" as surface;

.view {
  @include surface.dialog-overlay;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  backdrop-filter: blur(5px);

  .language {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    @include surface.dialog-panel;
    background: #1e1e1e;
    border: #2d2d2d solid 1px;

    .button {
      @include surface.button;
      margin-top: 8px;
      width: 100%;
      text-align: center;
      font-weight: bold;
      color: #fff;
      background: v-bind("config.themes_color");
    }

    .list {
      min-height: 0;
      height: auto;
      max-height: min(280px, 45vh);
      margin-top: 8px;
      padding: 0;
      gap: 6px;
      flex-shrink: 1;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .item {
        @include surface.press-feedback;
        min-height: 36px;
        padding: 6px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        background: #000;
        color: white;
        font-size: 14px;
        width: calc(50% - 3px); // 每行两个，减去间距的一半
        min-width: 0; // 防止flex项目溢出

        div:nth-child(2) {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          min-width: 0; // 确保文本可以正确截断
        }

        div:nth-child(3) {
          margin-right: 5px;
          font-size: 12px;
          flex-shrink: 0; // 防止状态文本被压缩
        }

        &>.img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
          background-size: contain;
          background-position: 50%;
          background-repeat: no-repeat;
          flex-shrink: 0; // 防止图标被压缩
        }
      }
    }

    .top {
      @include surface.dialog-header;
      position: relative;

      .top_left {
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .close {
        @include surface.close-button;
        img {
          width: 100%;
          height: 100%;
        }
      }

      &_title {
        @include surface.title;
        width: auto;
        font-weight: bold;
        color: white;
      }

      &_introduced {
        font-size: 13px;
        line-height: 1.5;
        margin-top: 4px;
        color: #ccc;
      }
    }
  }
}
.view .language .top .close img {
  width: 24px;
  height: 24px;
}
</style>
